import { c as _c } from "react/compiler-runtime";
import { SphereIconButton } from "@components/common/sphere-icon-button";
import { CopyIcon, grey, HEX_ALPHA, Link, NO_TRANSLATE_CLASS, Popover } from "@flat-ui";
import { alpha, Box } from "@mui-wrapper";
import { withEllipsis } from "@styles/common-styles";
import { copyToClipboard, getSvgColoredIconCss } from "@utils/ui-utils";
import { useState } from "react";

// The popover is a deliberately dark surface in both colour schemes, like the flat-ui tooltip,
// so the greys in this file are the pair that keeps it legible - not light-mode values left
// unconverted.

/** CSS style to apply when the button is hovered. */
const hoverStyle = {
  backgroundColor: alpha(grey[500], HEX_ALPHA.alpha28),
  ...getSvgColoredIconCss(grey[100])
};

/** CSS style to apply when the button is clicked. */
const clickStyle = {
  backgroundColor: alpha(grey[500], HEX_ALPHA.alpha46),
  ...getSvgColoredIconCss(grey[100])
};
/** Notification popover that shows task message */
export function SphereNotificationPopover(t0) {
  const $ = _c(24);
  const {
    label: t1,
    message,
    sx
  } = t0;
  const label = t1 === undefined ? "Details" : t1;
  const [notificationAnchorElement, setNotificationAnchorElement] = useState(null);
  const isMenuOpen = Boolean(notificationAnchorElement);
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = function handleClick(event) {
      setNotificationAnchorElement(event.currentTarget);
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const handleClick = t2;
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = function handleClose() {
      setNotificationAnchorElement(null);
    };
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const handleClose = t3;
  let t4;
  if ($[2] !== message) {
    t4 = function copyDetails() {
      copyToClipboard(message);
    };
    $[2] = message;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const copyDetails = t4;
  let t5;
  if ($[4] !== sx) {
    t5 = {
      ...withEllipsis,
      ...sx
    };
    $[4] = sx;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== label || $[7] !== t5) {
    t6 = <Link component="button" onClick={handleClick} sx={t5}>{label}</Link>;
    $[6] = label;
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      "& .MuiPaper-root": {
        width: "284px"
      }
    };
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== message) {
    t8 = <span className={NO_TRANSLATE_CLASS}>{message}</span>;
    $[10] = message;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = {
      display: "flex",
      justifyContent: "end"
    };
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = {
      sx: {
        "&:hover": {
          ...hoverStyle
        },
        "&:active": {
          ...clickStyle
        }
      }
    };
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  if ($[14] !== copyDetails) {
    t11 = <Box component="div" sx={t9}><SphereIconButton component={CopyIcon} onClick={copyDetails} iconSize="14px" buttonSize="20px" color={grey[100]} iconButtonProps={t10} /></Box>;
    $[14] = copyDetails;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  let t12;
  if ($[16] !== isMenuOpen || $[17] !== notificationAnchorElement || $[18] !== t11 || $[19] !== t8) {
    t12 = <Popover dark={true} open={isMenuOpen} anchorEl={notificationAnchorElement} onClose={handleClose} placement="bottom" showCloseButton={false} sx={t7} description={t8}>{t11}</Popover>;
    $[16] = isMenuOpen;
    $[17] = notificationAnchorElement;
    $[18] = t11;
    $[19] = t8;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] !== t12 || $[22] !== t6) {
    t13 = <>{t6}{t12}</>;
    $[21] = t12;
    $[22] = t6;
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  return t13;
}